import React, {useState} from 'react';
import IframeWidget from "../../../utils/IframeWidget";
import {Offcanvas, OffcanvasBody, OffcanvasHeader, OffcanvasTitle} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import PickUpDateItemDrawer from "./PickUpDateItemDrawer";
import {ReactComponent as BackIco} from "../../../../images/icons/arrow-left.svg";

interface Props {
    show: boolean;
    onHide: () => void;
    days: { label: string, value: string }[];
    date: string;
    handleChangeDate: (date: string) => void;
}

const PickUpDateMoreDaysDrawer = ({show, onHide, days, date, handleChangeDate}: Props) => {
    const {t} = useTranslation();
    const [value, setValue] = useState(date);

    const handleOnHide = () => {
        IframeWidget.onHide(onHide);
        onHide();
    }

    const handleSave = () => {
        handleChangeDate(value)
        handleOnHide();
    }

    return (
        <Offcanvas placement="end" show={show} onHide={handleOnHide} className='drawer pick-up-date-more-days-drawer'>
            <OffcanvasHeader>
                <OffcanvasTitle>
                    <BackIco className="me-2" onClick={handleOnHide} aria-label={t("common.action.close")} role="button"
                             tabIndex={0}/>
                    {t("modules.date_modal.field.another_day.title")}
                </OffcanvasTitle>
            </OffcanvasHeader>
            <OffcanvasBody>
                <div className="d-flex flex-column pick-up-date-drawer-section">
                    <div className="elements mt-2">
                        {days.map(day => (
                            <PickUpDateItemDrawer title={day.label} key={day.value} onClick={() => setValue(day.value)}
                                                  active={value === day.value}/>
                        ))}
                    </div>
                </div>
            </OffcanvasBody>
            <div className="offcanvas-footer">
                <div className="w-100 d-flex gap-3">
                    <button className="btn btn-default" onClick={onHide}>{t("common.action.cancel")}</button>
                    <button className={"btn-spinner btn-primary btn btn-submit w-100"} onClick={handleSave}
                            disabled={!value}>
                        {t("common.action.save")}
                    </button>
                </div>
            </div>
        </Offcanvas>
    )
}

export default PickUpDateMoreDaysDrawer;